module.exports = __webpack_public_path__ + "static/img/image.fe374666.svg";